import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';

import utils from './../../../utils/utilities';
import actions from './../FeedListing.actions';
import reduxStore from './../../../reduxStore';
import { compact } from 'lodash';

/**
 * Cell that contains PESTLE lines with associated risk percentages.
 *
 * @constructor
 * @param  {Array}           value         The label keys array.
 * @param  {number}          columnWidth   The width of the column as percentage.
 * @return {HTML}                          The table cell DOM elements.
 */
export function FeedListingPESTLERiskLinesCell({value, columnWidth, rowData, withDiv = false}) {

    let PESTLELines = [],
        angles = [
            'political',
            'economic',
            'social',
            'technological',
            'legal',
            'environmental'
        ],
        angleAbbreviations = ['P', 'E', 'S', 'T', 'L', 'E'];

    for (let i = 0; i < angles.length; i++) {
        let angleBarWidth       = rowData.metaData.riskLevels[angles[i]] * 33.333333,
            angleLevelMessageId = 'RSS_Feed_UIText_feedListing.tooltip.risk' + rowData.metaData.riskLevels[angles[i]];

        PESTLELines.push(
            <div className={'cell-pestle__element ' + angles[i]} key={'cell-pestle__element-' + i}>

                <span className="cell-pestle__element--label">
                    {angleAbbreviations[i]}
                </span>

                <span className="cell-pestle__element--bars"
                      onMouseEnter={actions.tooltipHandlerEnter}>

                    <span className="bar bar-gray"></span>

                    <span className="bar bar-blue" style={{width: angleBarWidth + '%'}}></span>

                    <span className="tooltip">
                        <FormattedMessage id={'RSS_Feed_UIText_feedListing.tooltip.' + angles[i]} />:&nbsp;
                        <FormattedMessage id={angleLevelMessageId} />
                    </span>

                </span>

            </div>
        );
    }

    return <div className="cell-pestle" style={{width: columnWidth + '%'}}>{PESTLELines}</div>;
}

/**
 * Cell that decides by its content to show either a Categories or a Third Parties cell.
 *
 * @constructor
 * @param  {Array}           value         The label keys array.
 * @param  {number}          columnWidth   The width of the column as percentage.
 * @return {HTML}                          The table cell DOM elements.
 */
function FeedListingCategoryOrThirdPartiesCell({value, columnWidth, intl}) {

    let cellData          = [],
        typeCategory      = false,
        cellLabels        = [],
        moreLabels        = [],
        categoryStore     = reduxStore.getState().feedListing.categoryStore,
        moreLabelsWrapper = null;

    if (!value.selectAllThirdParties) {
        if (utils.isArray(value.categories) && value.categories.length > 0) {

            for (let i = 0; i < value.categories.length; i++) {
                cellData.push(categoryStore[value.categories[i]]);
            }
            cellData.sort();

            typeCategory = true;

        } else if (utils.isArray(value.thirdParties) && value.thirdParties.length > 0) {
            cellData = value.thirdParties;
            cellData.sort();
        }
    }

    if (value.selectAllThirdParties) {
        cellLabels.push(
            <div className="cell-label-wrapper" title={intl.formatMessage({id: 'RSS_Feed_UIText_feedListing.allActive'})} key={'cell-label-wrapper-all'}>
                <div className="cell-third-parties__label">
                    <FormattedMessage id="RSS_Feed_UIText_feedListing.allActive" />
                </div>
            </div>
        );
    } else {
        cellData = compact(cellData);
        for (let i = 0; i < cellData.length; i++) {
            let insertArray = i < 3 ? cellLabels : moreLabels;

            insertArray.push(
                <div className="cell-label-wrapper" title={cellData[i]} key={'cell-label-' + i }>
                    <div className={typeCategory ? 'cell-categories__label' : 'cell-third-parties__label'}>
                        {cellData[i]}
                    </div>
                </div>
            );
        }

        if (cellData.length > 3) {
            moreLabelsWrapper = (
                <span className="cell-categories__more">
                ...
                <FormattedMessage id="RSS_Feed_UIText_feedListing.more" />
                <span className="tooltip-arrow"></span>
                <span className="tooltip-arrow-mask"></span>
                <div className="tooltip">
                    {moreLabels}
                </div>
            </span>
            );
        }
    }

    return (
        <td className={typeCategory ? 'cell-categories' : 'cell-third-parties'} style={{width: columnWidth + '%'}}>
            {cellLabels}
            {moreLabelsWrapper}
        </td>
    );

}
FeedListingCategoryOrThirdPartiesCell = injectIntl(FeedListingCategoryOrThirdPartiesCell);
export { FeedListingCategoryOrThirdPartiesCell };

/**
 * Cell that contains a Feed URL.
 *
 * @constructor
 * @param  {Array}           value         The label keys array.
 * @param  {number}          columnWidth   The width of the column as percentage.
 * @return {HTML}                          The table cell DOM elements.
 */
export function FeedListingUrlCell({value, columnWidth}) {

    let url = value;

    return (
        <td className="cell-feed-url" style={{width: columnWidth + '%'}}>

            <span className="cell-feed-url__label">
                <FormattedMessage id="RSS_Feed_UIText_feedListing.rssLink" />
            </span>

            <span className="cell-feed-url__content" title={url}>

                <span className="cell-feed-url__content--url">
                    {url}
                </span>

            </span>

        </td>
    );

}


// WEBPACK FOOTER //
// ./src/scripts/pages/FeedListing/template/FeedListingCellTypes.jsx